import { render, staticRenderFns } from "./tenantList.vue?vue&type=template&id=288dcb2e&scoped=true"
import script from "./tenantList.vue?vue&type=script&lang=js"
export * from "./tenantList.vue?vue&type=script&lang=js"
import style0 from "./tenantList.vue?vue&type=style&index=0&id=288dcb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288dcb2e",
  null
  
)

export default component.exports